export const PARTNER_ID_BING = 'bng_ref';
export const PARTNER_ID_CRM_RECO = 'crm_recoweb';
export const PARTNER_ID_CRM_RECO_CART = 'crm_recowk';
export const PARTNER_ID_GOOGLE_ORGANIC = 'google_organic';
export const PARTNER_ID_FACEBOOK = 'fb_ref';
export const PARTNER_ID_YOUTUBE = 'yt_ref';
